<template>
  <div v-if="!fetchingGroupSettings">
    <div
      v-show="editingOutputIndex === null || editingOutputIndex === undefined"
    >
      <paper
        :title="groupSettings.name"
        body-class="mt-0"
      >
        <div class="px-2 pb-1 text-break">
          <b-row>
            <b-col>
              <input-field
                name="file_group-custom_name"
                label="Custom name"
                label-position="top"
                :info="templateInfo.customName"
                info-position="label"
                @openInfo="openInfo"
              >
                <div>
                  {{ groupSettings.customName || '-' }}
                </div>
              </input-field>
            </b-col>
          </b-row>
          <b-row>
            <b-col />
          </b-row>
        </div>

        <div
          v-if="groupSettings.type === groupSettings.outputGroupsTypes.HLS || groupSettings.type === groupSettings.outputGroupsTypes.AppleSingleStreamHLS || groupSettings.type === groupSettings.outputGroupsTypes.AppleLLHLS"
          class="px-2 pb-1 pt-2 border-default border-t"
        >
          <b-row>
            <b-col
              cols="12"
              sm="6"
            >
              <input-field
                name="file_group-segment_control"
                label="Segment control"
                label-position="top"
                :info="templateInfo.segmentControl"
                info-position="label"
                @openInfo="openInfo"
              >
                {{
                  getText(
                    groupSettings.segmentControlOptions,
                    groupSettings.segmentControl,
                  )
                }}
              </input-field>
            </b-col>
            <b-col
              cols="12"
              sm="6"
            >
              <input-field
                name="file_group-segment_length"
                label="Segment length (sec)"
                label-position="top"
                :info="templateInfo.segmentLength"
                info-position="label"
                @openInfo="openInfo"
              >
                <div>
                  {{ groupSettings.segmentLength }}
                </div>
              </input-field>
            </b-col>
          </b-row>

          <b-row>
            <b-col
              cols="12"
              sm="6"
            >
              <input-field
                name="file_group-min_segment_length"
                label="Min segment length (sec)"
                label-position="top"
                :info="templateInfo.minSegmentLength"
                info-position="label"
                @openInfo="openInfo"
              >
                <div>
                  {{ groupSettings.minSegmentLength }}
                </div>
              </input-field>
            </b-col>

            <b-col
              cols="12"
              sm="6"
            >
              <input-field
                name="hls_size_length"
                label="HLS size length*"
                label-position="top"
                :info="templateInfo.hlsSizeLength"
                info-position="label"
                @openInfo="openInfo"
              >
                <div>
                  {{ groupSettings.hlsListLength }}
                </div>
              </input-field>
            </b-col>
          </b-row>
        </div>
      </paper>
      <paper
        v-if="
          groupSettings.type === groupSettings.outputGroupsTypes.HLS ||
            groupSettings.type === groupSettings.outputGroupsTypes.DASH
        "
        title="DRM"
        body-class="mt-0"
      >
        <drm-settings
          :drm-settings="groupSettings.drmList"
          :group-drm="groupSettings.groupDRM"
          :has-drm="groupSettings.hasDRM"
        />
      </paper>
      <paper
        title="Outputs"
        body-class="mt-0"
      >
        <outputs-table
          :outputs="groupSettings.outputs"
          :is-h-l-s="groupSettings.type === groupSettings.outputGroupsTypes.HLS"
          :is-dash="groupSettings.type === groupSettings.outputGroupsTypes.DASH"
          @editOutput="editOutput"
        />
      </paper>
    </div>
    <div
      v-if="
        editingOutputIndex !== null && groupSettings.outputs[editingOutputIndex]
      "
    >
      <single-output-settings
        ref="singleOutputsettings"
        :output="groupSettings.outputs[editingOutputIndex]"
        :group-type="groupSettings.type"
        :group-name="groupSettings.name"
        :is-h-l-s="groupSettings.type === groupSettings.outputGroupsTypes.HLS"
        :is-dash="groupSettings.type === groupSettings.outputGroupsTypes.DASH"
        @close="closeSingleOutputSettings"
        @openInfo="openInfo"
      />
    </div>
  </div>
  <loading-page v-else />
</template>

<script>
import Paper from '@/components/paper/Paper.vue'
import OutputsTable from './OutputsTable.vue'
import SingleOutputSettings from './SingleOutputSettings.vue'

import templateInfo from '../../settings/templateInfo'
import DrmSettings from './DrmSettings.vue'

export default {
  name: 'JobOutputSettings',
  components: {
    Paper,
    OutputsTable,
    SingleOutputSettings,
    DrmSettings,
  },
  props: {
    tab: {
      type: Object,
      default: null,
    },
    active: {
      type: String,
      default: null,
    },
    edit: {
      type: Boolean,
      default: null,
    },
    editingOutputIndex: {
      type: Number,
      default: null,
    },
    jobTemplate: {
      type: Object,
      default: null,
    },
    fromLiveJobs: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      templateInfo,
      fetchingGroupSettings: false,
      groupSettings: null,
      outputModel: null,
      lastAddedOutputName: 1,
    }
  },
  computed: {
    editingOutput() {
      return this.editingOutputIndex >= 0
    },
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      this.groupSettings = this.tab.outputGroup
      this.outputModel = this.edit
        ? { ...this.tab.outputGroup.emptyOutputModel }
        : { ...this.tab.outputGroup.outputs[0] }
      this.lastAddedOutputName = this.tab.outputGroup.outputs.length
    },
    closeSingleOutputSettings() {
      this.$emit('editingOutputIndex', null)
    },
    editOutput(index) {
      this.$emit('editingOutputIndex', index)
    },
    openInfo(e) {
      this.$emit('openInfo', e)
    },
  },
}
</script>

<style></style>
